import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DataService } from 'src/app/data.service';
import moment from 'moment';

// Újrahasználható bizonylat-szerkesztő (Billingo-jellegű kiállító felület). A modulok között
// újrahasználható: a Pénzügy "Új bizonylat" almenü mountolja, de bármelyik másik modul is
// beágyazhatja (<app-bizonylat-szerkeszto [csalad]="...">). A címzett vagy egy iskolai SZÜLŐ
// (kapja), vagy egy PARTNER a partnertörzsből (partner_id). A "Számviteli bizonylat" (tipus=10)
// NEM megy a NAV-ba, saját 'SZB' tömbből számozódik.
@Component({
  selector: 'app-bizonylat-szerkeszto',
  templateUrl: './bizonylat-szerkeszto.component.html',
  styleUrls: ['./bizonylat-szerkeszto.component.scss'],
})
export class BizonylatSzerkesztoComponent implements OnInit {
  // Opcionális előtöltés (pl. egyenleg-modálból): { users:[{id,nev,irsz,telepules,cim}], tetelek }
  @Input() csalad: any;
  @Input() beagyazott = false;

  JSON = JSON;
  sajatIntezmeny: any;
  loginmode: string;
  szamlaprofil: any = { bankszamla: [], onlinefiz: [], tombok: [] };
  orszagok: any[] = [];

  // Bizonylattípusok (index = szamla.tipus). nav=true → beküldhető a NAV-ba (csak szülőnél).
  bizonylatTipusok = [
    { tipus: 1, nev: 'Számla', ikon: 'receipt-outline', nav: true },
    { tipus: 2, nev: 'Előleg számla', ikon: 'card-outline', nav: true },
    { tipus: 3, nev: 'Díjbekérő', ikon: 'mail-outline', nav: false },
    { tipus: 4, nev: 'Nyugta', ikon: 'reader-outline', nav: false },
    { tipus: 5, nev: 'Árajánlat', ikon: 'clipboard-outline', nav: false },
    { tipus: 6, nev: 'Szállítólevél', ikon: 'cube-outline', nav: false },
    { tipus: 7, nev: 'Teljesítésigazolás', ikon: 'checkmark-done-outline', nav: false },
    { tipus: 10, nev: 'Számviteli bizonylat', ikon: 'document-text-outline', nav: false },
  ];
  bizonylattipus = 1;

  // Vevő (címzett)
  vevoMode: 'szulo' | 'partner' = 'szulo';
  szulok: any[] = [];
  valasztottSzulo: any = null;
  szuloKeres = '';
  szuloNyit = false;
  partnerek: any[] = [];
  valasztottPartner: any = null;
  partnerKeres = '';
  partnerNyit = false;
  ujPartnerNyit = false;
  ujPartner: any = this.uresPartner();

  tetelek: any[] = [];
  afaKulcsok = ['AAM', '27', '18', '5', '0', 'TAM'];

  // Fej (dátumok + fizetés + formátum)
  form: any = {
    kelt: moment().format('YYYY-MM-DD'),
    teljesites: moment().format('YYYY-MM-DD'),
    hatarido: moment().add(8, 'days').format('YYYY-MM-DD'),
    fizmod: 'Átutalás',
    biztomb: null,
    penznem: 'HUF',
    nyelv: 'Magyar',
    megjegyzes: '',
  };
  szamvitTomb: any = null;   // 'SZB' számviteli tömb (get-or-create)

  /*  Díjbekérő, fizetve, családi egyenleg (2026-10-15, a user kérése): a végszámla a szülő egyik
   *  díjbekérőjéhez köthető (választva, vagy ha nincs a rendszerben, a száma beírva); a bizonylat
   *  már fizetettként is kiállítható; és egy pipával a tételei a család egyenlegébe kerülnek. */
  dijbekerok: any[] = [];
  dijbekeroValasztas = '';        // '' = nincs, '__kezi' = beírt szám, egyébként a díjbekérő id-je
  dijbekeroKeziSzam = '';
  fizetve = false;
  fizetveDatum = moment().format('YYYY-MM-DD');
  csaladiEgyenleg = false;
  /** E-számla (alap): a PDF-et az intézmény tanúsítványa látható aláírással hitelesíti; papír: aláírás nélkül, nyomtatva adják át. */
  eszamla = true;

  ellenorzesHibak: string[] = [];
  ellenorizve = false;
  elonezetUrl: SafeResourceUrl = null;
  elonezetTolt = false;
  mentesFolyamat = false;

  @ViewChild('elonezetmodal') elonezetmodal: IonModal;

  constructor(
    private http: HttpClient,
    private data: DataService,
    private sanitizer: DomSanitizer,
  ) {}

  async ngOnInit() {
    this.loginmode = await this.data.getFromStorage('loginmode');
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    await this.betoltAdatok();
    // Előtöltés egyenlegből (opcionális): szülő-mód + tételek behúzása.
    if (this.csalad?.users?.length) {
      this.vevoMode = 'szulo';
      this.tetelekEgyenlegbol();
    }
  }

  uresPartner() {
    return { nev: '', adoszam: '', adozas: 1, orszag: 'Magyarország', irsz: '', telepules: '', cim: '', email: '' };
  }

  private hdr() {
    return { headers: { intezmeny: this.sajatIntezmeny.intezmenyId } };
  }

  async betoltAdatok() {
    const iid = this.sajatIntezmeny.intezmenyId;
    // Számlaprofil (kibocsátó + bankszámlák + tömbök)
    this.http.get('/api/szamla/intezmenyadatok/' + iid).subscribe((r: any) => {
      this.szamlaprofil = (r && r[0]) || this.szamlaprofil;
      try { if (typeof this.szamlaprofil.bankszamla === 'string') this.szamlaprofil.bankszamla = JSON.parse(this.szamlaprofil.bankszamla); } catch { }
      try { if (typeof this.szamlaprofil.onlinefiz === 'string') this.szamlaprofil.onlinefiz = JSON.parse(this.szamlaprofil.onlinefiz); } catch { }
      try { if (typeof this.szamlaprofil.tombok === 'string') this.szamlaprofil.tombok = JSON.parse(this.szamlaprofil.tombok); } catch { }
      this.szamlaprofil.tombok = (this.szamlaprofil.tombok || []).filter((t: any) => t && t.id);
      this.tombValasztas();
    });
    // Iskolai szülők (címzett-opció) – gyermek-hozzárendeléssel
    this.http.get('/api/nyilvantartas/szulo/' + iid, this.hdr()).subscribe((r: any) => {
      this.szulok = (r || []).filter((s: any) => s && s.username);
    });
    // Partnertörzs
    this.frissitPartnerek();
    // Országok (partner címzéshez)
    this.http.get('/api/nyilvantartas/orszagok', this.hdr()).subscribe((r: any) => { this.orszagok = r || []; });
    // Számviteli tömb (get-or-create)
    this.http.get('/api/szamla/szamviteli-tomb/' + iid).subscribe((r: any) => { this.szamvitTomb = r; });
  }

  frissitPartnerek(q = '') {
    const url = '/api/partner/' + this.sajatIntezmeny.intezmenyId + (q ? ('?q=' + encodeURIComponent(q)) : '');
    this.http.get(url).subscribe((r: any) => { this.partnerek = r || []; });
  }

  // ── Bizonylattípus + tömb ───────────────────────────────────────────────
  aktualisTipus() {
    return this.bizonylatTipusok.find(b => b.tipus === this.bizonylattipus);
  }

  valasztTipus(t: number) {
    this.bizonylattipus = t;
    this.ellenorizve = false;
    this.tombValasztas();
  }

  // A tömb (sorszám-sáv) kiválasztása: számviteli bizonylat → mindig a saját 'SZB' tömb;
  // egyébként az alapértelmezett (def=1) tömb, vagy az első.
  tombValasztas() {
    if (this.bizonylattipus === 10 && this.szamvitTomb) {
      this.form.biztomb = this.szamvitTomb.id;
      return;
    }
    const tombok = this.szamlaprofil.tombok || [];
    // Ne a storno/módosító/számviteli tömböket ajánljuk fel alapnak.
    const rendes = tombok.filter((t: any) => !t.storno && !t.modosito && !t.szamviteli);
    const def = rendes.find((t: any) => t.def) || rendes[0] || tombok[0];
    this.form.biztomb = def ? def.id : null;
  }

  valaszthatoTombok() {
    const tombok = this.szamlaprofil.tombok || [];
    if (this.bizonylattipus === 10) {
      //  A tandíj-tömb (szamlatomb.tandij) a tandíj-befizetések gépi bizonylataié – kézzel nem választható.
      const sz = tombok.filter((t: any) => t.szamviteli && !Number(t.tandij));
      // Ha az intezmenyadatok még nem hozta be a (frissen auto-létrehozott) SZB tömböt, a külön
      // lekért szamvitTomb-öt is felkínáljuk, hogy a lista sose legyen üres.
      if (this.szamvitTomb && !sz.some((t: any) => t.id === this.szamvitTomb.id)) sz.push(this.szamvitTomb);
      return sz;
    }
    return tombok.filter((t: any) => !t.storno && !t.modosito && !t.szamviteli);
  }

  // ── Vevő ────────────────────────────────────────────────────────────────
  vevoModeValt(mode: 'szulo' | 'partner') {
    this.vevoMode = mode;
    this.ellenorizve = false;
    // NAV-os számlát csak szülőnek állítunk ki (a partneres NAV-beküldés külön feladat);
    // partnernél a Számviteli bizonylatra váltunk, ha épp NAV-os típus volt kiválasztva.
    if (mode === 'partner' && this.aktualisTipus()?.nav) {
      this.valasztTipus(10);
    }
  }

  // Szülő-kereső (saját, native combo – nem Ionic-komponens, hogy a design tiszta legyen)
  szuloCimke(s: any) {
    return s?.full_name || `${s?.vez || ''} ${s?.ker || ''}`.trim();
  }
  szurtSzulok() {
    const q = this.szuloKeres.trim().toLowerCase();
    if (!q) return this.szulok.slice(0, 40);
    return this.szulok.filter((s) => this.szuloCimke(s).toLowerCase().includes(q)).slice(0, 40);
  }
  szuloValaszt(s: any) {
    this.valasztottSzulo = s;
    this.szuloKeres = this.szuloCimke(s);
    this.szuloNyit = false;
    this.ellenorizve = false;
    this.dijbekeroValasztas = '';
    this.dijbekerokBetolt();
  }

  // ── Díjbekérő / fizetve / családi egyenleg ─────────────────────────────
  /** A díjbekérő-hivatkozás a számlánál és az előleg számlánál értelmes. */
  dijbekeroKell() { return this.vevoMode === 'szulo' && [1, 2].includes(this.bizonylattipus); }
  /** Fizetettre állítani a „pénzügyi” bizonylatokat lehet (árajánlatot, szállítólevelet nem). */
  fizetveKell() { return ![5, 6, 7].includes(this.bizonylattipus); }
  keszpenz() { return this.form.fizmod === 'Készpénz'; }

  dijbekerokBetolt() {
    this.dijbekerok = [];
    const u = this.valasztottSzulo?.username;
    if (!u) return;
    this.http.get('/api/szamla/vegszamlazhato-dijbekerok/' + this.sajatIntezmeny.intezmenyId + '?kapja=' + encodeURIComponent(u))
      .subscribe({ next: (r: any) => { this.dijbekerok = Array.isArray(r) ? r : []; }, error: () => { this.dijbekerok = []; } });
  }

  valasztottDijbekero() { return this.dijbekerok.find((d) => d.id === this.dijbekeroValasztas) || null; }

  dijbekeroValt() {
    this.ellenorizve = false;
    const d = this.valasztottDijbekero();
    if (!d) return;
    //  A díjbekérő kiírása már a családi egyenlegben van – a végszámlát nem vezetjük be újra.
    this.csaladiEgyenleg = false;
    if (!this.tetelek.length) this.tetelek = (d.tetelek || []).map((t: any) => ({ ...t, mennyiseg: Number(t.mennyiseg) || 1 }));
    if (d.fiz_mod) this.form.fizmod = d.fiz_mod;
    if (d.fizetve) this.fizetve = true;
  }
  szuloBlur() { setTimeout(() => (this.szuloNyit = false), 160); }

  // Partner-kereső (native combo)
  szurtPartnerek() {
    const q = this.partnerKeres.trim().toLowerCase();
    if (!q) return this.partnerek.slice(0, 40);
    return this.partnerek.filter((p) =>
      `${p.nev} ${p.adoszam || ''} ${p.telepules || ''}`.toLowerCase().includes(q)).slice(0, 40);
  }
  partnerValaszt(p: any) {
    this.valasztottPartner = p;
    this.partnerKeres = p?.nev || '';
    this.partnerNyit = false;
    this.ujPartnerNyit = false;
    this.ellenorizve = false;
  }
  partnerBlur() { setTimeout(() => (this.partnerNyit = false), 160); }

  async ujPartnerMent() {
    if (!this.ujPartner.nev?.trim()) { this.data.sendToast('A partner neve kötelező!', 'error'); return; }
    const body = { ...this.ujPartner, intezmeny: this.sajatIntezmeny.intezmenyId };
    this.http.post('/api/partner', body).subscribe({
      next: (r: any) => {
        this.data.sendToast('Partner mentve a törzsbe!', 'success');
        const ujId = r?.id;
        this.http.get('/api/partner/' + this.sajatIntezmeny.intezmenyId).subscribe((list: any) => {
          this.partnerek = list || [];
          this.valasztottPartner = this.partnerek.find((p: any) => p.id === ujId) || null;
          this.partnerKeres = this.valasztottPartner?.nev || '';
          this.ujPartnerNyit = false;
          this.ujPartner = this.uresPartner();
        });
      },
      error: (e) => this.data.sendToast('Hiba a partner mentésekor: ' + JSON.stringify(e?.error || e), 'error'),
    });
  }

  // A címzett kártyához / előnézethez összeállított egységes vevő-objektum.
  vevoObjektum() {
    if (this.vevoMode === 'partner') {
      const p = this.ujPartnerNyit ? this.ujPartner : this.valasztottPartner;
      if (!p) return null;
      return { nev: p.nev, adoszam: p.adoszam, orszag: p.orszag, irsz: p.irsz, telepules: p.telepules, cim: p.cim };
    }
    const s = this.valasztottSzulo;
    if (!s) return null;
    return {
      nev: s.full_name || `${s.vez || ''} ${s.ker || ''}`.trim(),
      adoszam: '',
      orszag: 'Magyarország',
      irsz: s.irsz, telepules: s.telepules, cim: s.cim,
    };
  }

  // ── Tételek ─────────────────────────────────────────────────────────────
  addTetel() {
    this.tetelek.push({ nev: '', alrendszer: null, osszeg: 0, afa: 'AAM', mennyiseg: 1, megyseg: 'db' });
    this.ellenorizve = false;
  }

  deleteTetel(i: number) {
    this.tetelek.splice(i, 1);
    this.ellenorizve = false;
  }

  tetelekEgyenlegbol() {
    (this.csalad?.tetelek || []).forEach((g: any) => {
      if ((!g.kapcsolat && g.osszeg < 0 && !g.szamla) || (g.osszeg > 0 && !g.szamla)) {
        this.tetelek.push({ ...g, afa: 'AAM', mennyiseg: 1, megyseg: 'hó' });
      }
    });
  }

  osszesen() {
    return (this.tetelek || []).reduce((s, t) => s + (Number(t.osszeg) || 0), 0);
  }

  // ── Ellenőrzés / előnézet / kiállítás ───────────────────────────────────
  ellenoriz(csendes = false): boolean {
    const h: string[] = [];
    if (!this.bizonylattipus) h.push('Válassz bizonylattípust.');
    const vevo = this.vevoObjektum();
    if (this.vevoMode === 'szulo' && !this.valasztottSzulo) h.push('Válassz szülőt (címzett).');
    if (this.vevoMode === 'partner' && !this.valasztottPartner && !this.ujPartnerNyit) h.push('Válassz partnert, vagy adj meg újat.');
    if (this.vevoMode === 'partner' && this.ujPartnerNyit && !this.ujPartner.nev?.trim()) h.push('Add meg az új partner nevét (és mentsd a törzsbe).');
    if (this.vevoMode === 'partner' && this.ujPartnerNyit) h.push('Mentsd az új partnert a törzsbe a kiállítás előtt.');
    if (!vevo?.nev) h.push('Hiányzik a címzett neve.');
    if (!this.form.biztomb) h.push('Nincs kiválasztható bizonylattömb (sorszám-sáv).');
    if (!this.tetelek.length) h.push('Adj hozzá legalább egy tételt.');
    this.tetelek.forEach((t, i) => {
      if (!t.nev?.trim()) h.push(`A ${i + 1}. tétel megnevezése üres.`);
      if (!(Number(t.mennyiseg) > 0)) h.push(`A ${i + 1}. tétel mennyisége nem lehet 0.`);
      if (!(Number(t.osszeg) > 0)) h.push(`A ${i + 1}. tétel egységára nem lehet 0.`);
    });
    if (!this.form.kelt) h.push('Add meg a kelt dátumot.');
    if (this.dijbekeroKell() && this.dijbekeroValasztas === '__kezi' && !this.dijbekeroKeziSzam.trim()) h.push('Írd be a díjbekérő számát, vagy válaszd a „nincs” lehetőséget.');
    if (this.fizetve && !this.fizetveDatum) h.push('Add meg a fizetés dátumát.');
    this.ellenorzesHibak = h;
    this.ellenorizve = true;
    if (!csendes) {
      if (h.length) this.data.sendToast(`${h.length} hiányosság a kitöltésben.`, 'error');
      else this.data.sendToast('A bizonylat kitöltése rendben van.', 'success');
    }
    return h.length === 0;
  }

  private elonezetBody() {
    const vevo = this.vevoObjektum() || {};
    const tomb = (this.szamlaprofil.tombok || []).find((t: any) => t.id === this.form.biztomb);
    return {
      bizonylattipus: this.bizonylattipus,
      elotag: tomb?.elotag || '',
      kelt: this.form.kelt, teljesites: this.form.teljesites, hatarido: this.form.hatarido,
      fizmod: this.form.fizmod,
      vevo,
      tetelek: this.tetelek,
      dijbekero: this.dijbekeroSzoveg(),
      fizetve: this.fizetveKell() && (this.fizetve || this.keszpenz()),
      eszamla: this.eszamla,
    };
  }

  /** A PDF „Díjbekérő:” sorába kerülő szám. */
  dijbekeroSzoveg() {
    if (!this.dijbekeroKell()) return '';
    if (this.dijbekeroValasztas === '__kezi') return this.dijbekeroKeziSzam.trim();
    return this.valasztottDijbekero()?.szamlaszam || '';
  }

  async elonezet() {
    this.elonezetTolt = true;
    this.elonezetUrl = null;
    await this.elonezetmodal?.present();
    this.http.post('/api/nav/preview/' + this.sajatIntezmeny.intezmenyId, this.elonezetBody(), { responseType: 'blob' })
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);
          this.elonezetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          this.elonezetTolt = false;
        },
        error: (e) => {
          this.elonezetTolt = false;
          this.data.sendToast('Az előnézet nem készült el.', 'error');
          console.error(e);
        },
      });
  }

  async kiallit() {
    if (!this.ellenoriz()) return;
    if (this.vevoMode === 'partner' && !this.valasztottPartner?.id) {
      this.data.sendToast('Előbb mentsd/válaszd ki a partnert a törzsből.', 'error');
      return;
    }
    this.mentesFolyamat = true;
    await this.data.showLoading('Bizonylat kiállítása...');
    const body: any = {
      bizonylattipus: this.bizonylattipus,
      tetelek: this.tetelek,
      form: {
        biztomb: this.form.biztomb,
        osszesen: this.osszesen(),
        fizmod: this.form.fizmod,
        kapja: this.vevoMode === 'szulo' ? this.valasztottSzulo?.username : '',
        partner_id: this.vevoMode === 'partner' ? this.valasztottPartner?.id : null,
        proforma_id: this.dijbekeroKell() && this.valasztottDijbekero() ? this.dijbekeroValasztas : null,
        dijbekero_szam: this.dijbekeroKell() && this.dijbekeroValasztas === '__kezi' ? this.dijbekeroKeziSzam.trim() : '',
        fizetve: this.fizetveKell() && this.fizetve,
        fizetve_datum: this.fizetveDatum,
        csaladi_egyenleg: this.vevoMode === 'szulo' && this.csaladiEgyenleg && !this.valasztottDijbekero(),
        eszamla: this.eszamla,
      },
      intezmeny: this.sajatIntezmeny,
    };
    this.http.post('/api/szamla/create', body).subscribe({
      next: (r: any) => {
        const id = r && r[0] ? r[0].id : null;
        const eg = r && r[0] ? r[0].egyenleg : null;
        if (eg?.hiba) this.data.sendToast(eg.hiba, 'warning');
        this.http.get('/api/nav/geninvoice/' + id + '/' + this.sajatIntezmeny.intezmenyId).subscribe({
          next: () => {
            this.data.hideLoading();
            this.mentesFolyamat = false;
            this.data.sendToast('Bizonylat kiállítva!', 'success');
            this.ujBizonylat();
          },
          error: (e) => {
            this.data.hideLoading();
            this.mentesFolyamat = false;
            this.data.sendToast('A bizonylat mentve, de a PDF-generálás hibázott: ' + JSON.stringify(e?.error || e), 'error');
          },
        });
      },
      error: (e) => {
        this.data.hideLoading();
        this.mentesFolyamat = false;
        this.data.sendToast('Hiba a kiállításkor: ' + JSON.stringify(e?.error || e), 'error');
      },
    });
  }

  ujBizonylat() {
    this.tetelek = [];
    this.valasztottSzulo = null;
    this.valasztottPartner = null;
    this.szuloKeres = '';
    this.partnerKeres = '';
    this.ujPartner = this.uresPartner();
    this.ujPartnerNyit = false;
    this.ellenorizve = false;
    this.ellenorzesHibak = [];
    this.form.kelt = moment().format('YYYY-MM-DD');
    this.form.teljesites = moment().format('YYYY-MM-DD');
    this.form.hatarido = moment().add(8, 'days').format('YYYY-MM-DD');
    this.dijbekerok = [];
    this.dijbekeroValasztas = '';
    this.dijbekeroKeziSzam = '';
    this.fizetve = false;
    this.fizetveDatum = moment().format('YYYY-MM-DD');
    this.csaladiEgyenleg = false;
    this.eszamla = true;
  }

  elonezetZar() {
    this.elonezetmodal?.dismiss();
    this.elonezetUrl = null;
  }
}
